module.exports = __webpack_public_path__ + "static/media/wab32_1015.992fa78a.ico";